const GetAllBanksForIfsc = (data: any) => {
  const retData = data.map((item: any) => ({
    id: item?.bankId,
    name: item?.bankName,
    rank: 0,
    isPopular: false,
    logo: item?.logo ? item.logo : '',
    bankCode: item?.banjId,
    ifscCode: item?.ifsc ?? '',
    iin: item?.iin ?? '',
    accountName: item?.accountName ?? '',
  }))
  return retData
}

export { GetAllBanksForIfsc }
